/**
 * MicrosoftClarity — session-recording / heatmap loader, gated by env var.
 *
 * Off by default (no env var → returns null). Set `NEXT_PUBLIC_CLARITY_ID` to
 * your Clarity project id to enable; the script auto-injects from Microsoft's
 * CDN. We render via `next/script` with `strategy="lazyOnload"` so it doesn't
 * block interactive — analytics is never on the critical path.
 *
 * Privacy posture (Clarity-side knobs are configured in the Clarity dashboard):
 *   - Mask: ON globally (covers all input fields + content)
 *   - IP anonymization: ON
 *   - Cookie consent: We rely on the platform-wide consent banner gating this
 *     entire component — for now, the env-var gate alone holds the line and
 *     production won't flip it on until the consent flow ships.
 */

"use client";

import Script from "next/script";

const CLARITY_ID = process.env.NEXT_PUBLIC_CLARITY_ID ?? "";

export function MicrosoftClarity() {
    if (!CLARITY_ID) return null;

    return (
        <Script
            id="ms-clarity"
            strategy="lazyOnload"
            dangerouslySetInnerHTML={{
                __html: `
(function(c,l,a,r,i,t,y){
  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", ${JSON.stringify(CLARITY_ID)});
            `.trim(),
            }}
        />
    );
}
